import React from "react";
import {
  Container,
  IsRequiredStar,
  Label,
  Span,
  TextArea,
} from "../../Styles/Global.Styled";
import { css } from "styled-components";
import { inputChangehandlers } from "../../helpers/formHandlers";

const TextAreaInput = ({
  properties,
  setForm,
  index,
}) => {
  const {
    label,
    required,
    value,
    errors,
    minLength,
    maxLength,
    width,
    mWidth,
    height,
    mHeight,
    onChangeHandler,
    handleValidation,
  } = properties ?? {};

  const runValidation = () => {
    // const { value } = e.target;
    const handler = inputChangehandlers[handleValidation];
    // const validatorHandler = validatorsHandler[validator];
    if (handler ) {
      handler(
        setForm,
        // validatorHandler,
        properties,
        index
      );
    }
  };

  const handleChange = (e) => {
    const { value } = e.target;
    const handler = inputChangehandlers[onChangeHandler];
    if (handler) {
      handler(setForm, index, value);
    }

    if (errors !== null) {
      runValidation();
    }
  };

  return (
    <Container
      $baseStyle={css`
        width: ${width};
        height: ${height};
      `}
      $mStyle={css`
        width: ${mWidth};
        height: ${mHeight};
      `}
    >
      <TextArea
        $baseStyle={css`
          width: 100%;
          font-size: 2vh;
          padding: 1vh;
        `}
        minLength={minLength}
        maxLength={maxLength}
        required={required}
        value={value}
        onChange={handleChange}
        onBlur={(e) => {
          if (errors === null) return runValidation(e);
        }}
      />
      <Label
        $baseStyle={css`
          position: absolute;
          top: -1.5vh;
          left: 1vh;
          z-index: 1;
          background-color: white;
        `}
      >
        {label}
        {required && <IsRequiredStar />}
      </Label>
      <Label
        $baseStyle={css`
          position: absolute;
          left: 70%;
          top: 92%;
          font-size: 1.2vh;
          background-color: white;
        `}
      >
        {`${value.length + "/" + maxLength} characters`}
        {required && <IsRequiredStar />}
      </Label>
      {errors && (
        <Span
          $baseStyle={css`
            position: absolute;
            color: red;
            font-size: 1.35vh;
            height: 1.5vh;
            bottom: -1.9vh;
          `}
        >
          {errors}
        </Span>
      )}
    </Container>
  );
};

export default TextAreaInput;
